import { toNumber } from "lodash"

const onlyNumbers = (time: string) => /^[\s\d]+$/.test(time)

// 1h 5m -> 65
export const parseDurationStringToMinutes = (time: string) => {
  let hours = 0
  let minutes = 0
  const splittedTime = time.split('h')

  if (time.indexOf('h') > -1 && onlyNumbers(splittedTime[0])) {
    hours = Math.abs(toNumber(splittedTime[0]))
  }
  if (time.indexOf('m') > -1) {
    const minutesPart = splittedTime[splittedTime.length - 1].split('m')[0]

    if (onlyNumbers(minutesPart)) minutes = Math.abs(toNumber(minutesPart))
  }

  const result = hours * 60 + minutes

  // If nothing got parsed but time is a string with only numbers
  // return this number as minutes
  if (result == 0 && onlyNumbers(time)) {
    return parseInt(time)
  }

  return result
}

export const formatTimeInMinutes = (timeInMinutes: number) => {
  let minutes = timeInMinutes % 60
  let hours = Math.floor(timeInMinutes / 60)

  if (timeInMinutes < 60) {
    return `${minutes}m`
  } else {
    return `${hours}h ${minutes}m`
  }
}